<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-section">
        <h3>About</h3>
        <p>MethArDB is developed and maintained by the <a href="https://sgxy.njtech.edu.cn/" target="_blank" rel="noopener noreferrer">College of Biotechnology and Pharmaceutical Engineering, Nanjing Tech University</a> and <a href="https://chem.xmu.edu.cn/" target="_blank" rel="noopener noreferrer">College of Chemistry and Chemical Engineering, Xiamen University</a>.</p>
      </div>
      <div class="footer-section">
        <h3>Contact</h3>
        <p>Email: zhoujun@njtech.edu.cn</p>
        <p>Email: wypp@xmu.edu.cn</p>
      </div>
    </div>
    <div class="footer-data-source">
      <p>Data Source: <a href="https://www.ncbi.nlm.nih.gov/" target="_blank" rel="noopener noreferrer">NCBI</a>. Please cite: "NCBI Resource Coordinators. Database resources of the National Center for Biotechnology Information. Nucleic Acids Research, 2024."
      </p>
    </div>
    <div class="footer-bottom">
      <p>&copy; 2025 Bioenergy Research Institute. All rights reserved.</p >
      <p><a href=" " target="_blank" class="icp-link">赣ICP备2025069942号</a ></p >
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
.footer {
  background: linear-gradient(to bottom, #1e293b, #0f172a);
  color: #f8fafc;
  padding: 30px 0 15px;
  position: relative;
  z-index: 0;
  border-top: 1px solid #334155;
  flex-shrink: 0;
  width: 100%;
  margin-top: auto;
}

.footer-content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 40px;
}

.footer-section h3 {
  color: #f1f5f9;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  position: relative;
  padding-bottom: 8px;
}

.footer-section h3::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 30px;
  height: 2px;
  background: linear-gradient(to right, #60a5fa, #3b82f6);
  border-radius: 2px;
}

.footer-section p {
  color: #cbd5e1;
  line-height: 1.5;
  margin-bottom: 12px;
}

.footer-section a {
  color: #60a5fa;
  text-decoration: none;
  transition: color 0.3s;
  font-weight: 500;
}

.footer-section a:hover {
  color: #93c5fd;
}

.footer-data-source {
  max-width: 1280px;
  margin: 20px auto 0;
  padding: 15px 20px 0;
  border-top: 1px solid #334155;
  text-align: center;
}

.footer-data-source p {
  color: #94a3b8;
  font-size: 14px;
}

.footer-data-source a {
  color: #60a5fa;
  text-decoration: none;
  transition: color 0.3s;
}

.footer-data-source a:hover {
  color: #93c5fd;
}

.footer-bottom {
  max-width: 1280px;
  margin: 15px auto 0;
  padding: 15px 20px 0;
  border-top: 1px solid #334155;
  text-align: center;
}

.footer-bottom p {
  color: #94a3b8;
  font-size: 14px;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>